module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-grid"
  }, _vm._l((_vm.movies), function(movie, key) {
    return _c('movie-list', {
      key: movie.id,
      attrs: {
        "movie": movie,
        "index": key
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54def4e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BahnzieleMoviesList.vue
// module id = 83
// module chunks = 0